<template>
  <section class="ugc-rotate-image-control">
    <div 
      id="rotateLabel"
      class="ugc-rotate-image-control-value">
      {{ RotateValue }}&deg;
    </div>
    <input
      class="ugc-rotate-image-control-input"
      v-model="RotateValue"
      type="range"
      min="-360"
      max="360"
      @input="onInputChange"
      role="slider"
      aria-labelledby="rotateLabel"
      aria-valuemin="-360"
      aria-valuemax="360"
      :aria-valuenow="RotateValue"
    />
    <!-- insert done and cancel controls here -->
  </section>
</template>

<script>
import BaseUgcTool from "../BaseUgcTool";
export default {
  extends: BaseUgcTool,
  name: "UgcRotateImageControl",
  data() {
    return {
      RotateValue: "0",
      controlName: "rotate",
      object: null
    };
  },
  methods: {
    onRotateListener() {
      this.RotateValue = parseInt(this.object.get("angle"));
    },
    onInputChange() {
      this.object.set("angle", parseInt(this.RotateValue)).setCoords();
      this.fabricCanvas.requestRenderAll();
    }
  },
  computed: {
    fabricCanvas() {
      return this.$store.state.ugc.stateManager.canvas;
    }
  },
  created() {
    this.object = this.fabricCanvas.getObjects("image")[0];
    this.object.on("rotating", this.onRotateListener);
    this.RotateValue = parseInt(this.object.get("angle"));
  },
  beforeDestroy() {
    this.object.off("rotating", this.onRotateListener);
  }
};
</script>
